export default class TemplatePolicy {
    static browse(user) {
        return user.hasPermissionTo('browse:templates');
    }

    static add(user) {
        return user.hasPermissionTo('add:templates');
    }

    /* eslint-disable-next-line no-unused-vars */
    static edit(user, template) {
        return user.hasPermissionTo('edit:templates');
    }

    static duplicate(user, template) {
        return this.add(user) && this.edit(user, template);
    }

    static destroy(user, template) {
        return template.canDelete;
    }
}
